import { useContext, useEffect, useState } from "react";
import { UserContext } from "../UserContext";

export default function useUserRoles() {
  const [userRoles, setUserRoles] = useState<Array<string> | undefined>();
  const { getUser } = useContext(UserContext);
  useEffect(() => {
    getUser().then((user) => {
      if (user?.roles) {
        const roles = user.roles.split(",");
        setUserRoles(roles);
      }
    });
  }, [getUser]);

  return userRoles;
}
